import React from "react";

/** Collection of all the svg icons used in the app */

/** Close Icon SVG */
export const CloseSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
    <path d="M7,5l5-5,2,2L9,7l5,5-2,2L7,9,2,14,0,12,5,7,0,2,2,0Z" />
  </svg>
);

/** Plus Icon SVG */
export const PlusSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
    <path d="M9.29,6.1H7.73V4.54a.72.72,0,0,0-.34-.63.78.78,0,0,0-1.19.66h0V6.1H4.64A.71.71,0,0,0,4,6.45a.77.77,0,0,0,.65,1.19H6.2V9.2a.72.72,0,0,0,.34.63.78.78,0,0,0,1.19-.66h0V7.64H9.27a.77.77,0,0,0,.65-1.19A.71.71,0,0,0,9.29,6.1ZM7,0a7,7,0,1,0,7,7h0A7,7,0,0,0,7,0Zm.12,12.52A5.53,5.53,0,1,1,12.65,7h0a5.54,5.54,0,0,1-5.53,5.53Z" />
  </svg>
);

/** Question Icon SVG */
export const QuestionSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
    <path d="M7,14a7,7,0,1,1,7-7A7,7,0,0,1,7,14ZM7,1.58A5.42,5.42,0,1,0,12.42,7h0A5.42,5.42,0,0,0,7,1.58Z" />
    <path d="M6.2,8.23a2.64,2.64,0,0,1,.16-1,2.09,2.09,0,0,1,.58-.77,3,3,0,0,0,.56-.61,1,1,0,0,0,.14-.5c0-.52-.24-.79-.73-.79a.76.76,0,0,0-.55.21.87.87,0,0,0-.22.59H4.79a1.8,1.8,0,0,1,.58-1.39,2.25,2.25,0,0,1,1.54-.5,2.2,2.2,0,0,1,1.54.48A1.64,1.64,0,0,1,9,5.26,1.75,1.75,0,0,1,8.82,6a3.44,3.44,0,0,1-.62.79l-.38.34a1.29,1.29,0,0,0-.41.8l0,.29ZM6.06,9.66a.7.7,0,0,1,.22-.51A.71.71,0,0,1,6.82,9a.71.71,0,0,1,.54.2.7.7,0,0,1,.22.51.69.69,0,0,1-.21.51.85.85,0,0,1-1.1,0A.69.69,0,0,1,6.06,9.66Z" />
  </svg>
);

/** Star Full Icon SVG */
export const StarFullSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
    <path d="M7,11l4.32,2.61L10.17,8.73,14,5.42,9,5,7,.35,5,5,0,5.42,3.82,8.73,2.67,13.65Z" />
  </svg>
);

/** Star Line Icon SVG */
export const StarLineSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
    <path d="M7,3.35l.87,2.1.3.65.7.06,2.27.19L9.4,7.84l-.53.47L9,9l.52,2.22L7.6,10,7,9.67,6.38,10,4.44,11.2,5,9l.16-.68-.53-.47L2.85,6.35l2.27-.19.7-.06.29-.65L7,3.35m0-3L5,5,0,5.42,3.82,8.73,2.67,13.64,7,11l4.32,2.61L10.16,8.73,14,5.42,9,5Z" />
  </svg>
);

/** Link Icon SVG */
export const LinkIconSVG = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
    <path d="M12.8 1.2a3.676 3.676 0 0 0-5.19 0L5.57 3.24c.16-.01.33-.02.49-.02.51 0 1.02.08 1.5.24L8.72 2.3c.83-.82 2.16-.81 2.98.01.81.82.81 2.15 0 2.97L9.43 7.55A2.112 2.112 0 0 1 6 6.89c-.26.01-.5.12-.68.3l-.61.61a3.662 3.662 0 0 0 4.97 1.48c.31-.17.6-.38.85-.63l2.27-2.27a3.664 3.664 0 0 0 0-5.18z" />
    <path d="M7.96 10.78c-.52 0-1.03-.09-1.52-.25L5.28 11.7c-.83.82-2.16.81-2.98-.01-.81-.82-.81-2.15 0-2.97l2.27-2.27c.82-.82 2.16-.82 2.98 0 .19.19.35.41.45.66.26-.01.5-.12.69-.3l.6-.6a3.669 3.669 0 0 0-4.97-1.5c-.31.17-.6.39-.85.64L1.2 7.62a3.664 3.664 0 0 0 5.18 5.18l2.04-2.04c-.14.01-.3.02-.46.02z" />
  </svg>
);

/** Toggle icon */
export const ToggleSVG = (
  <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.8898 4.48894L13.667 4.26613C13.5195 4.11865 13.281 4.11865 13.1335 4.26613L7.00176 10.401L0.866885 4.26613C0.719397 4.11865 0.480905 4.11865 0.333417 4.26613L0.110616 4.48894C-0.036872 4.63642 -0.036872 4.87492 0.110616 5.0224L6.73189 11.6468C6.87938 11.7943 7.11787 11.7943 7.26536 11.6468L13.8866 5.0224C14.0373 4.87492 14.0373 4.63642 13.8898 4.48894Z" />
  </svg>
);

/** Verified icon */
export const VerifiedSVG = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.998 7.999a2.75 2.75 0 00-1.784-2.575 2.75 2.75 0 00-3.64-3.64 2.75 2.75 0 00-5.15 0 2.75 2.75 0 00-3.641 3.64 2.75 2.75 0 000 5.15 2.75 2.75 0 003.64 3.64 2.75 2.75 0 005.15 0 2.75 2.75 0 003.641-3.64 2.75 2.75 0 001.784-2.575zm-4.525-1.383L7.38 10.679a.344.344 0 01-.486-.002L4.527 8.29a.344.344 0 01.002-.486L5.342 7A.344.344 0 015.828 7l1.318 1.328 3.037-3.014a.344.344 0 01.486.002l.807.813a.344.344 0 01-.003.486z" />
  </svg>
);

/** Menu expand icon */
export const MenuExpandSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.25 12C10.25 12.116 10.2961 12.2273 10.3781 12.3094C10.4602 12.3914 10.5715 12.4375 10.6875 12.4375H15.7564L13.8777 14.3153C13.7956 14.3974 13.7494 14.5088 13.7494 14.625C13.7494 14.7412 13.7956 14.8526 13.8777 14.9347C13.9599 15.0169 14.0713 15.0631 14.1875 15.0631C14.3037 15.0631 14.4151 15.0169 14.4973 14.9347L17.1222 12.3098C17.163 12.2691 17.1953 12.2208 17.2174 12.1677C17.2394 12.1145 17.2508 12.0575 17.2508 12C17.2508 11.9425 17.2394 11.8855 17.2174 11.8323C17.1953 11.7792 17.163 11.7309 17.1222 11.6902L14.4973 9.06525C14.4151 8.9831 14.3037 8.93695 14.1875 8.93695C14.0713 8.93695 13.9599 8.9831 13.8777 9.06525C13.7956 9.1474 13.7494 9.25882 13.7494 9.375C13.7494 9.49118 13.7956 9.6026 13.8777 9.68475L15.7564 11.5625H10.6875C10.5715 11.5625 10.4602 11.6086 10.3781 11.6906C10.2961 11.7727 10.25 11.884 10.25 12ZM8.0625 18.125C7.94647 18.125 7.83519 18.0789 7.75314 17.9969C7.67109 17.9148 7.625 17.8035 7.625 17.6875V6.3125C7.625 6.19647 7.67109 6.08519 7.75314 6.00314C7.83519 5.92109 7.94647 5.875 8.0625 5.875C8.17853 5.875 8.28981 5.92109 8.37186 6.00314C8.45391 6.08519 8.5 6.19647 8.5 6.3125V17.6875C8.5 17.8035 8.45391 17.9148 8.37186 17.9969C8.28981 18.0789 8.17853 18.125 8.0625 18.125Z"
      fill="#272937"
    />
    <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#E5E5E7" />
  </svg>
);

/** Menu collapse icon */
export const MenuCollapseSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.9374 18.125C15.8214 18.125 15.7101 18.0789 15.6281 17.9969C15.546 17.9148 15.4999 17.8035 15.4999 17.6875V6.3125C15.4999 6.19647 15.546 6.08519 15.6281 6.00314C15.7101 5.92109 15.8214 5.875 15.9374 5.875C16.0535 5.875 16.1647 5.92109 16.2468 6.00314C16.3288 6.08519 16.3749 6.19647 16.3749 6.3125V17.6875C16.3749 17.8035 16.3288 17.9148 16.2468 17.9969C16.1647 18.0789 16.0535 18.125 15.9374 18.125ZM13.7499 12C13.7499 12.116 13.7038 12.2273 13.6218 12.3094C13.5397 12.3914 13.4285 12.4375 13.3124 12.4375H8.24355L10.1222 14.3153C10.1629 14.3559 10.1951 14.4042 10.2171 14.4574C10.2391 14.5105 10.2505 14.5675 10.2505 14.625C10.2505 14.6825 10.2391 14.7395 10.2171 14.7926C10.1951 14.8458 10.1629 14.8941 10.1222 14.9347C10.0815 14.9754 10.0332 15.0077 9.98006 15.0297C9.92692 15.0517 9.86995 15.0631 9.81243 15.0631C9.7549 15.0631 9.69794 15.0517 9.64479 15.0297C9.59165 15.0077 9.54335 14.9754 9.50268 14.9347L6.87768 12.3098C6.83693 12.2691 6.80461 12.2208 6.78255 12.1677C6.7605 12.1145 6.74915 12.0575 6.74915 12C6.74915 11.9425 6.7605 11.8855 6.78255 11.8323C6.80461 11.7792 6.83693 11.7309 6.87768 11.6902L9.50268 9.06525C9.58483 8.9831 9.69625 8.93695 9.81243 8.93695C9.92861 8.93695 10.04 8.9831 10.1222 9.06525C10.2043 9.1474 10.2505 9.25882 10.2505 9.375C10.2505 9.49118 10.2043 9.6026 10.1222 9.68475L8.24355 11.5625H13.3124C13.4285 11.5625 13.5397 11.6086 13.6218 11.6906C13.7038 11.7727 13.7499 11.884 13.7499 12Z"
      fill="#272937"
    />
    <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#E5E5E7" />
  </svg>
);

/** Menu switch icon */
export const MenuSwitchIconSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.17881 8.02239C8.32506 6.63364 10.0601 5.74989 12.0001 5.74989C13.4408 5.75006 14.8372 6.24776 15.9532 7.15882C17.0693 8.06986 17.8364 9.33836 18.125 10.7498H16.4176C16.3582 10.7499 16.3001 10.7668 16.25 10.7987C16.1999 10.8305 16.1599 10.876 16.1347 10.9298C16.1095 10.9836 16.1002 11.0434 16.1078 11.1023C16.1154 11.1612 16.1396 11.2167 16.1776 11.2623L18.6351 14.2123C18.6644 14.2475 18.7011 14.2758 18.7426 14.2952C18.7841 14.3146 18.8293 14.3247 18.8751 14.3247C18.9209 14.3247 18.9661 14.3146 19.0076 14.2952C19.0491 14.2758 19.0858 14.2475 19.1151 14.2123L21.5726 11.2623C21.6106 11.2167 21.6348 11.1612 21.6424 11.1023C21.65 11.0434 21.6407 10.9836 21.6155 10.9298C21.5903 10.876 21.5503 10.8305 21.5002 10.7987C21.4501 10.7668 21.392 10.7499 21.3326 10.7498H19.3963C19.1558 9.33292 18.5135 8.01488 17.5456 6.9525C16.5777 5.89009 15.325 5.12805 13.9365 4.757C12.5481 4.38595 11.0822 4.42151 9.71339 4.85946C8.34455 5.2974 7.1303 6.1193 6.21506 7.22739C6.15966 7.29025 6.11747 7.36361 6.09099 7.44311C6.06452 7.52261 6.05429 7.60662 6.06094 7.69015C6.06758 7.77368 6.09095 7.85502 6.12966 7.92933C6.16836 8.00365 6.22162 8.06942 6.28626 8.12274C6.35089 8.17606 6.42559 8.21584 6.50591 8.23971C6.58623 8.26358 6.67053 8.27105 6.7538 8.26169C6.83707 8.25233 6.9176 8.22632 6.99061 8.18521C7.06363 8.1441 7.12763 8.08873 7.17881 8.02239ZM7.48691 16.3226C6.6705 15.4709 6.1117 14.4057 5.87506 13.2499H4.60381C4.84427 14.6668 5.48665 15.9849 6.45455 17.0473C7.42244 18.1097 8.67512 18.8717 10.0636 19.2428C11.4521 19.6138 12.9179 19.5783 14.2867 19.1403C15.6556 18.7024 16.8698 17.8805 17.7851 16.7724C17.8405 16.7095 17.8827 16.6362 17.9091 16.5567C17.9356 16.4772 17.9458 16.3932 17.9392 16.3096C17.9325 16.2261 17.9092 16.1448 17.8705 16.0704C17.8318 15.9961 17.7785 15.9304 17.7139 15.877C17.6492 15.8237 17.5745 15.7839 17.4942 15.7601C17.4139 15.7362 17.3296 15.7287 17.2463 15.7381C17.1631 15.7474 17.0825 15.7735 17.0095 15.8146C16.9365 15.8557 16.8725 15.911 16.8213 15.9774C16.07 16.887 15.0767 17.5655 13.9562 17.9345C12.8356 18.3035 11.6335 18.348 10.4888 18.0627C9.34401 17.7775 8.30331 17.1742 7.48691 16.3226ZM7.58261 13.2498H2.66761C2.60823 13.2498 2.55008 13.2329 2.49998 13.201C2.44988 13.1691 2.4099 13.1236 2.38472 13.0699C2.35954 13.0161 2.3502 12.9562 2.35779 12.8974C2.36539 12.8385 2.3896 12.783 2.42761 12.7373L4.88511 9.78733C4.91444 9.75216 4.95113 9.72387 4.99261 9.70445C5.03408 9.68503 5.07931 9.67497 5.12511 9.67497C5.1709 9.67497 5.21613 9.68503 5.25761 9.70445C5.29908 9.72387 5.33578 9.75216 5.36511 9.78733L7.82261 12.7373C7.86061 12.783 7.88483 12.8385 7.89242 12.8974C7.90002 12.9562 7.89068 13.0161 7.8655 13.0699C7.84031 13.1236 7.80033 13.1691 7.75023 13.201C7.70013 13.2329 7.64199 13.2498 7.58261 13.2498Z"
      fill="#272937"
    />
  </svg>
);

/** Menu plus icon */
export const MenuPlusSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 6.75C12.116 6.75 12.2273 6.79609 12.3094 6.87814C12.3914 6.96019 12.4375 7.07147 12.4375 7.1875V11.5625H16.8125C16.9285 11.5625 17.0398 11.6086 17.1219 11.6906C17.2039 11.7727 17.25 11.884 17.25 12C17.25 12.116 17.2039 12.2273 17.1219 12.3094C17.0398 12.3914 16.9285 12.4375 16.8125 12.4375H12.4375V16.8125C12.4375 16.9285 12.3914 17.0398 12.3094 17.1219C12.2273 17.2039 12.116 17.25 12 17.25C11.884 17.25 11.7727 17.2039 11.6906 17.1219C11.6086 17.0398 11.5625 16.9285 11.5625 16.8125V12.4375H7.1875C7.07147 12.4375 6.96019 12.3914 6.87814 12.3094C6.79609 12.2273 6.75 12.116 6.75 12C6.75 11.884 6.79609 11.7727 6.87814 11.6906C6.96019 11.6086 7.07147 11.5625 7.1875 11.5625H11.5625V7.1875C11.5625 7.07147 11.6086 6.96019 11.6906 6.87814C11.7727 6.79609 11.884 6.75 12 6.75Z"
      fill="#272937"
    />
  </svg>
);

/** Menu plus-box icon */
export const MenuPlusBoxSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="4" fill="#F4F4F5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 6.75C12.116 6.75 12.2273 6.79609 12.3094 6.87814C12.3914 6.96019 12.4375 7.07147 12.4375 7.1875V11.5625H16.8125C16.9285 11.5625 17.0398 11.6086 17.1219 11.6906C17.2039 11.7727 17.25 11.884 17.25 12C17.25 12.116 17.2039 12.2273 17.1219 12.3094C17.0398 12.3914 16.9285 12.4375 16.8125 12.4375H12.4375V16.8125C12.4375 16.9285 12.3914 17.0398 12.3094 17.1219C12.2273 17.2039 12.116 17.25 12 17.25C11.884 17.25 11.7727 17.2039 11.6906 17.1219C11.6086 17.0398 11.5625 16.9285 11.5625 16.8125V12.4375H7.1875C7.07147 12.4375 6.96019 12.3914 6.87814 12.3094C6.79609 12.2273 6.75 12.116 6.75 12C6.75 11.884 6.79609 11.7727 6.87814 11.6906C6.96019 11.6086 7.07147 11.5625 7.1875 11.5625H11.5625V7.1875C11.5625 7.07147 11.6086 6.96019 11.6906 6.87814C11.7727 6.79609 11.884 6.75 12 6.75Z"
      fill="#272937"
    />
  </svg>
);

/** Menu share icon */
export const MenuShareSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_646_17503)">
      <path
        d="M4.84188 14.3823C5.59542 14.3823 6.3181 14.0711 6.85094 13.5173C7.38378 12.9634 7.68313 12.2122 7.68313 11.429C7.68313 10.6457 7.38378 9.89452 6.85094 9.34067C6.3181 8.78682 5.59542 8.47567 4.84188 8.47567C4.08816 8.47567 3.36532 8.78689 2.83237 9.34086C2.29941 9.89483 2 10.6462 2 11.4296C2 12.213 2.29941 12.9644 2.83237 13.5184C3.36532 14.0723 4.08816 14.3836 4.84188 14.3836V14.3823ZM16.6756 7.90658C17.4292 7.90658 18.1519 7.59543 18.6847 7.04158C19.2175 6.48773 19.5169 5.73655 19.5169 4.95329C19.5169 4.17003 19.2175 3.41885 18.6847 2.865C18.1519 2.31115 17.4292 2 16.6756 2C15.9221 2 15.1994 2.31115 14.6666 2.865C14.1337 3.41885 13.8344 4.17003 13.8344 4.95329C13.8344 5.73655 14.1337 6.48773 14.6666 7.04158C15.1994 7.59543 15.9221 7.90658 16.6756 7.90658ZM11.2506 19.0311C10.2463 18.8103 9.30178 18.36 8.48562 17.7128C7.66945 17.0656 7.00208 16.2377 6.53188 15.2892C5.77149 15.6485 4.92351 15.7573 4.10187 15.601C4.66998 17.061 5.57443 18.3536 6.73571 19.3651C7.897 20.3767 9.27956 21.0763 10.7619 21.4023C11.4244 21.5491 12.1019 21.6219 12.7794 21.618C12.2577 20.9073 11.9662 20.043 11.9469 19.1494C11.713 19.122 11.4807 19.0826 11.2506 19.0311ZM16.0356 22C16.4087 22 16.7782 21.9236 17.1229 21.7752C17.4676 21.6268 17.7809 21.4092 18.0447 21.135C18.3085 20.8608 18.5178 20.5352 18.6606 20.1769C18.8034 19.8186 18.8769 19.4345 18.8769 19.0467C18.8769 18.6589 18.8034 18.2748 18.6606 17.9165C18.5178 17.5582 18.3085 17.2327 18.0447 16.9584C17.7809 16.6842 17.4676 16.4666 17.1229 16.3182C16.7782 16.1698 16.4087 16.0934 16.0356 16.0934C15.2821 16.0934 14.5594 16.4046 14.0266 16.9584C13.4937 17.5123 13.1944 18.2634 13.1944 19.0467C13.1944 19.83 13.4937 20.5812 14.0266 21.135C14.5594 21.6889 15.2821 22 16.0356 22ZM19.9894 17.9618C21.2077 16.3647 21.9089 14.408 21.9926 12.3716C22.0764 10.3353 21.5384 8.32352 20.4556 6.62418C20.1277 7.42789 19.57 8.10737 18.8581 8.57052C19.4263 9.68599 19.7041 10.9365 19.664 12.1979C19.6239 13.4594 19.2672 14.6881 18.6294 15.7621C19.2945 16.3279 19.7706 17.0978 19.9894 17.9618ZM4.62313 7.19457C5.45696 7.14917 6.28426 7.36947 6.99437 7.82603C7.62066 6.8855 8.45343 6.11351 9.42376 5.57397C10.3941 5.03443 11.4741 4.74283 12.5744 4.72332C12.6206 3.85279 12.9206 3.01735 13.4369 2.32872C11.6754 2.19045 9.91241 2.57421 8.35235 3.43548C6.7923 4.29674 5.4992 5.60019 4.62313 7.19457Z"
        fill="#B3B4B9"
      />
    </g>
    <defs>
      <clipPath id="clip0_646_17503">
        <rect width="20" height="20" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);

/** Menu notifications icon */
export const MenuNotificationsSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.9017 8.40165C21.6049 7.69839 22 6.74456 22 5.75C22 4.75544 21.6049 3.80161 20.9017 3.09835C20.1984 2.39509 19.2446 2 18.25 2C17.2554 2 16.3016 2.39509 15.5983 3.09835C14.8951 3.80161 14.5 4.75544 14.5 5.75C14.5 6.74456 14.8951 7.69839 15.5983 8.40165C16.3016 9.10491 17.2554 9.5 18.25 9.5C19.2446 9.5 20.1984 9.10491 20.9017 8.40165ZM5.78141 5.78141C6.60188 4.96094 7.71468 4.5 8.875 4.5H12C12.1658 4.5 12.3247 4.43415 12.4419 4.31694C12.5592 4.19973 12.625 4.04076 12.625 3.875C12.625 3.70924 12.5592 3.55027 12.4419 3.43306C12.3247 3.31585 12.1658 3.25 12 3.25H8.875C7.38316 3.25 5.95242 3.84263 4.89752 4.89752C3.84263 5.95242 3.25 7.38316 3.25 8.875V15.125C3.25 16.6168 3.84263 18.0476 4.89752 19.1025C5.95242 20.1574 7.38316 20.75 8.875 20.75H15.125C16.6168 20.75 18.0476 20.1574 19.1025 19.1025C20.1574 18.0476 20.75 16.6168 20.75 15.125V12C20.75 11.8342 20.6842 11.6753 20.5669 11.5581C20.4497 11.4408 20.2908 11.375 20.125 11.375C19.9592 11.375 19.8003 11.4408 19.6831 11.5581C19.5658 11.6753 19.5 11.8342 19.5 12V15.125C19.5 16.2853 19.0391 17.3981 18.2186 18.2186C17.3981 19.0391 16.2853 19.5 15.125 19.5H8.875C7.71468 19.5 6.60188 19.0391 5.78141 18.2186C4.96094 17.3981 4.5 16.2853 4.5 15.125V8.875C4.5 7.71468 4.96094 6.60188 5.78141 5.78141Z"
      fill="#B3B4B9"
    />
  </svg>
);

/** Menu live chat icon */
export const MenuLivechatSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.3475 16.8675C5.47725 16.9977 5.57667 17.155 5.63868 17.3281C5.70069 17.5011 5.72376 17.6857 5.70625 17.8687C5.6184 18.7157 5.45185 19.5527 5.20875 20.3687C6.9525 19.965 8.0175 19.4975 8.50125 19.2525C8.77563 19.1135 9.09161 19.0806 9.38875 19.16C10.2405 19.3871 11.1185 19.5014 12 19.5C16.995 19.5 20.75 15.9913 20.75 12C20.75 8.01 16.995 4.5 12 4.5C7.005 4.5 3.25 8.01 3.25 12C3.25 13.835 4.02125 15.5375 5.3475 16.8675ZM4.73125 21.7487C4.43509 21.8075 4.13796 21.8612 3.84 21.91C3.59 21.95 3.4 21.69 3.49875 21.4575C3.60974 21.1957 3.71147 20.9302 3.80375 20.6612L3.8075 20.6488C4.1175 19.7487 4.37 18.7138 4.4625 17.75C2.92875 16.2125 2 14.2 2 12C2 7.1675 6.4775 3.25 12 3.25C17.5225 3.25 22 7.1675 22 12C22 16.8325 17.5225 20.75 12 20.75C11.0096 20.7513 10.0232 20.6227 9.06625 20.3675C8.41625 20.6963 7.0175 21.295 4.73125 21.7487Z"
      fill="#B3B4B9"
    />
  </svg>
);

/** Menu what's new icon */
export const MenuWhatsnewSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_646_18249)">
      <path
        d="M18.25 5.125C18.25 4.62772 18.4475 4.15081 18.7992 3.79917C19.1508 3.44754 19.6277 3.25 20.125 3.25C20.6223 3.25 21.0992 3.44754 21.4508 3.79917C21.8025 4.15081 22 4.62772 22 5.125V18.875C22 19.3723 21.8025 19.8492 21.4508 20.2008C21.0992 20.5525 20.6223 20.75 20.125 20.75C19.6277 20.75 19.1508 20.5525 18.7992 20.2008C18.4475 19.8492 18.25 19.3723 18.25 18.875V18.6075C15.5475 17.0563 12.6375 16.3038 9.61 16.0038L10.1163 19.3938C10.1502 19.5744 10.144 19.7602 10.098 19.9381C10.0519 20.1161 9.96723 20.2816 9.8499 20.4231C9.73257 20.5645 9.58549 20.6783 9.41914 20.7565C9.2528 20.8346 9.07127 20.875 8.8875 20.875H8.2025C7.95953 20.875 7.72183 20.8042 7.51847 20.6712C7.31512 20.5382 7.15493 20.3488 7.0575 20.1263L4.745 15.7638C4.66084 15.7624 4.57667 15.7611 4.4925 15.76C3.83046 15.7534 3.19765 15.4863 2.73113 15.0165C2.26461 14.5467 2.00194 13.9121 2 13.25L2 10.75C2.00223 10.0879 2.26446 9.4531 2.7302 8.98245C3.19595 8.5118 3.82792 8.24292 4.49 8.23375C5.52503 8.21971 6.55976 8.18846 7.59375 8.14C11.3975 7.9475 15.2787 7.07875 18.25 5.39125V5.125ZM19.5 5.125V18.875C19.5 19.0408 19.5658 19.1997 19.6831 19.3169C19.8003 19.4342 19.9592 19.5 20.125 19.5C20.2908 19.5 20.4497 19.4342 20.5669 19.3169C20.6842 19.1997 20.75 19.0408 20.75 18.875V5.125C20.75 4.95924 20.6842 4.80027 20.5669 4.68306C20.4497 4.56585 20.2908 4.5 20.125 4.5C19.9592 4.5 19.8003 4.56585 19.6831 4.68306C19.5658 4.80027 19.5 4.95924 19.5 5.125ZM18.25 6.8125C15.32 8.31875 11.7387 9.115 8.25 9.35375V14.645C8.475 14.6575 8.69875 14.6725 8.92125 14.69C12.1313 14.9263 15.2875 15.62 18.25 17.1813V6.8125ZM7 14.5813V9.41875C6.17025 9.44911 5.3402 9.47078 4.51 9.48375C4.17596 9.48767 3.85681 9.62254 3.62118 9.85933C3.38555 10.0961 3.25227 10.416 3.25 10.75V13.25C3.25 13.9375 3.81 14.5025 4.5075 14.5113C5.33866 14.5209 6.16961 14.5442 7 14.5813ZM6.17875 15.8L8.19 19.5963L8.2025 19.6263H8.8875L8.885 19.6088L8.33125 15.9013C7.61421 15.858 6.89665 15.8238 6.17875 15.7988V15.8Z"
        fill="#B3B4B9"
      />
    </g>
    <defs>
      <clipPath id="clip0_646_18249">
        <rect width="20" height="20" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);

/** Menu help icon */
export const MenuHelpSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_646_28538)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.81282 18.1872C7.45376 19.8281 9.67936 20.75 12 20.75C14.3206 20.75 16.5462 19.8281 18.1872 18.1872C19.8281 16.5462 20.75 14.3206 20.75 12C20.75 9.67936 19.8281 7.45376 18.1872 5.81282C16.5462 4.17187 14.3206 3.25 12 3.25C9.67936 3.25 7.45376 4.17187 5.81282 5.81282C4.17187 7.45376 3.25 9.67936 3.25 12C3.25 14.3206 4.17187 16.5462 5.81282 18.1872ZM19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711ZM8.58775 9.3509C8.57332 9.31316 8.56675 9.27287 8.56846 9.2325C8.68721 7.1125 10.4222 6.375 12.006 6.375C13.7522 6.375 15.3472 7.2875 15.3472 9.17625C15.3472 10.525 14.5535 11.1675 13.7922 11.7463C12.871 12.445 12.5297 12.7063 12.5297 13.6038V13.735C12.5297 13.8179 12.4968 13.8974 12.4382 13.956C12.3796 14.0146 12.3001 14.0475 12.2172 14.0475H11.2035C11.1214 14.0475 11.0427 14.0153 10.9842 13.9577C10.9258 13.9002 10.8923 13.822 10.891 13.74L10.8872 13.4688C10.8397 12.31 11.506 11.5963 12.3472 10.985C13.086 10.43 13.5535 10.065 13.5535 9.27125C13.5535 8.24 12.7685 7.81125 11.911 7.81125C10.9085 7.81125 10.346 8.40875 10.2335 9.22875C10.211 9.4 10.0735 9.54125 9.90096 9.54125H8.86971C8.82931 9.54197 8.7892 9.53442 8.75183 9.51906C8.71446 9.5037 8.68062 9.48085 8.65241 9.45194C8.62419 9.42302 8.60219 9.38863 8.58775 9.3509ZM11.7772 17.595C11.046 17.595 10.5147 17.1025 10.5147 16.4362C10.5147 15.7463 11.046 15.2613 11.776 15.2613C12.5372 15.2613 13.0622 15.7463 13.0622 16.4362C13.0622 17.1025 12.5385 17.595 11.7772 17.595Z"
        fill="#B3B4B9"
      />
    </g>
    <defs>
      <clipPath id="clip0_646_28538">
        <rect width="20" height="20" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);

/** Menu three dots icon */
export const MenuThreeDotsSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.75 13.875C5.25272 13.875 4.77581 13.6775 4.42417 13.3258C4.07254 12.9742 3.875 12.4973 3.875 12C3.875 11.5027 4.07254 11.0258 4.42417 10.6742C4.77581 10.3225 5.25272 10.125 5.75 10.125C6.24728 10.125 6.72419 10.3225 7.07583 10.6742C7.42746 11.0258 7.625 11.5027 7.625 12C7.625 12.4973 7.42746 12.9742 7.07583 13.3258C6.72419 13.6775 6.24728 13.875 5.75 13.875ZM12 13.875C11.5027 13.875 11.0258 13.6775 10.6742 13.3258C10.3225 12.9742 10.125 12.4973 10.125 12C10.125 11.5027 10.3225 11.0258 10.6742 10.6742C11.0258 10.3225 11.5027 10.125 12 10.125C12.4973 10.125 12.9742 10.3225 13.3258 10.6742C13.6775 11.0258 13.875 11.5027 13.875 12C13.875 12.4973 13.6775 12.9742 13.3258 13.3258C12.9742 13.6775 12.4973 13.875 12 13.875ZM18.25 13.875C17.7527 13.875 17.2758 13.6775 16.9242 13.3258C16.5725 12.9742 16.375 12.4973 16.375 12C16.375 11.5027 16.5725 11.0258 16.9242 10.6742C17.2758 10.3225 17.7527 10.125 18.25 10.125C18.7473 10.125 19.2242 10.3225 19.5758 10.6742C19.9275 11.0258 20.125 11.5027 20.125 12C20.125 12.4973 19.9275 12.9742 19.5758 13.3258C19.2242 13.6775 18.7473 13.875 18.25 13.875Z"
      fill="#272937"
    />
  </svg>
);

/** Menu email icon */
export const MenuEmailSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 7C2 6.33696 2.26339 5.70107 2.73223 5.23223C3.20107 4.76339 3.83696 4.5 4.5 4.5H19.5C20.163 4.5 20.7989 4.76339 21.2678 5.23223C21.7366 5.70107 22 6.33696 22 7V17C22 17.663 21.7366 18.2989 21.2678 18.7678C20.7989 19.2366 20.163 19.5 19.5 19.5H4.5C3.83696 19.5 3.20107 19.2366 2.73223 18.7678C2.26339 18.2989 2 17.663 2 17V7ZM4.5 5.75C4.16848 5.75 3.85054 5.8817 3.61612 6.11612C3.3817 6.35054 3.25 6.66848 3.25 7V7.27125L12 12.5212L20.75 7.27125V7C20.75 6.66848 20.6183 6.35054 20.3839 6.11612C20.1495 5.8817 19.8315 5.75 19.5 5.75H4.5ZM20.75 8.72875L14.865 12.26L20.75 15.8812V8.72875ZM20.7075 17.3237L13.6575 12.985L12 13.9788L10.3425 12.985L3.2925 17.3225C3.36353 17.5885 3.5204 17.8236 3.73874 17.9913C3.95708 18.159 4.22468 18.25 4.5 18.25H19.5C19.7752 18.25 20.0426 18.1593 20.261 17.9918C20.4793 17.8243 20.6362 17.5895 20.7075 17.3237ZM3.25 15.8812L9.135 12.26L3.25 8.72875V15.8812Z"
      fill="#B3B4B9"
    />
  </svg>
);

/** Menu paper icon */
export const MenuPaperSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 2H13.875L19.5 7.625V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM14.4242 7.07583C14.0725 6.72419 13.875 6.24728 13.875 5.75V3.25H7C6.66848 3.25 6.35054 3.3817 6.11612 3.61612C5.8817 3.85054 5.75 4.16848 5.75 4.5V19.5C5.75 19.8315 5.8817 20.1495 6.11612 20.3839C6.35054 20.6183 6.66848 20.75 7 20.75H17C17.3315 20.75 17.6495 20.6183 17.8839 20.3839C18.1183 20.1495 18.25 19.8315 18.25 19.5V7.625H15.75C15.2527 7.625 14.7758 7.42746 14.4242 7.07583ZM8.43306 10.9331C8.55027 10.8158 8.70924 10.75 8.875 10.75H15.125C15.2908 10.75 15.4497 10.8158 15.5669 10.9331C15.6842 11.0503 15.75 11.2092 15.75 11.375C15.75 11.5408 15.6842 11.6997 15.5669 11.8169C15.4497 11.9342 15.2908 12 15.125 12H8.875C8.70924 12 8.55027 11.9342 8.43306 11.8169C8.31585 11.6997 8.25 11.5408 8.25 11.375C8.25 11.2092 8.31585 11.0503 8.43306 10.9331ZM8.43306 13.4331C8.31585 13.5503 8.25 13.7092 8.25 13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H15.125C15.2908 14.5 15.4497 14.4342 15.5669 14.3169C15.6842 14.1997 15.75 14.0408 15.75 13.875C15.75 13.7092 15.6842 13.5503 15.5669 13.4331C15.4497 13.3158 15.2908 13.25 15.125 13.25H8.875C8.70924 13.25 8.55027 13.3158 8.43306 13.4331ZM8.43306 15.9331C8.31585 16.0503 8.25 16.2092 8.25 16.375C8.25 16.5408 8.31585 16.6997 8.43306 16.8169C8.55027 16.9342 8.70924 17 8.875 17H11.375C11.5408 17 11.6997 16.9342 11.8169 16.8169C11.9342 16.6997 12 16.5408 12 16.375C12 16.2092 11.9342 16.0503 11.8169 15.9331C11.6997 15.8158 11.5408 15.75 11.375 15.75H8.875C8.70924 15.75 8.55027 15.8158 8.43306 15.9331Z"
      fill="#B3B4B9"
    />
  </svg>
);

/** Inline button icon, plus */
export const ButtonPlusSVG = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 2.75C8.61603 2.75 8.72731 2.79609 8.80936 2.87814C8.89141 2.96019 8.9375 3.07147 8.9375 3.1875V7.5625H13.3125C13.4285 7.5625 13.5398 7.60859 13.6219 7.69064C13.7039 7.77269 13.75 7.88397 13.75 8C13.75 8.11603 13.7039 8.22731 13.6219 8.30936C13.5398 8.39141 13.4285 8.4375 13.3125 8.4375H8.9375V12.8125C8.9375 12.9285 8.89141 13.0398 8.80936 13.1219C8.72731 13.2039 8.61603 13.25 8.5 13.25C8.38397 13.25 8.27269 13.2039 8.19064 13.1219C8.10859 13.0398 8.0625 12.9285 8.0625 12.8125V8.4375H3.6875C3.57147 8.4375 3.46019 8.39141 3.37814 8.30936C3.29609 8.22731 3.25 8.11603 3.25 8C3.25 7.88397 3.29609 7.77269 3.37814 7.69064C3.46019 7.60859 3.57147 7.5625 3.6875 7.5625H8.0625V3.1875C8.0625 3.07147 8.10859 2.96019 8.19064 2.87814C8.27269 2.79609 8.38397 2.75 8.5 2.75Z"
      fill="#272937"
    />
  </svg>
);

/** Inline button icon, logout */
export const ButtonLogoutSVG = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_921_37810)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.62186 12.2469C9.70391 12.1648 9.75 12.0535 9.75 11.9375V10.1875C9.75 10.0715 9.79609 9.96019 9.87814 9.87814C9.96019 9.79609 10.0715 9.75 10.1875 9.75C10.3035 9.75 10.4148 9.79609 10.4969 9.87814C10.5789 9.96019 10.625 10.0715 10.625 10.1875V11.9375C10.625 12.2856 10.4867 12.6194 10.2406 12.8656C9.99444 13.1117 9.6606 13.25 9.3125 13.25H2.3125C1.9644 13.25 1.63056 13.1117 1.38442 12.8656C1.13828 12.6194 1 12.2856 1 11.9375V4.0625C1 3.7144 1.13828 3.38056 1.38442 3.13442C1.63056 2.88828 1.9644 2.75 2.3125 2.75H9.3125C9.6606 2.75 9.99444 2.88828 10.2406 3.13442C10.4867 3.38056 10.625 3.7144 10.625 4.0625V5.8125C10.625 5.92853 10.5789 6.03981 10.4969 6.12186C10.4148 6.20391 10.3035 6.25 10.1875 6.25C10.0715 6.25 9.96019 6.20391 9.87814 6.12186C9.79609 6.03981 9.75 5.92853 9.75 5.8125V4.0625C9.75 3.94647 9.70391 3.83519 9.62186 3.75314C9.53981 3.67109 9.42853 3.625 9.3125 3.625H2.3125C2.19647 3.625 2.08519 3.67109 2.00314 3.75314C1.92109 3.83519 1.875 3.94647 1.875 4.0625V11.9375C1.875 12.0535 1.92109 12.1648 2.00314 12.2469C2.08519 12.3289 2.19647 12.375 2.3125 12.375H9.3125C9.42853 12.375 9.53981 12.3289 9.62186 12.2469ZM14.9674 8.16757C14.9453 8.22073 14.913 8.269 14.8722 8.30964L12.2472 10.9346C12.1651 11.0168 12.0537 11.0629 11.9375 11.0629C11.8213 11.0629 11.7099 11.0168 11.6278 10.9346C11.5456 10.8525 11.4994 10.7411 11.4994 10.6249C11.4994 10.5087 11.5456 10.3973 11.6278 10.3151L13.5064 8.43739H5.8125C5.69647 8.43739 5.58519 8.3913 5.50314 8.30925C5.42109 8.22721 5.375 8.11593 5.375 7.99989C5.375 7.88386 5.42109 7.77258 5.50314 7.69054C5.58519 7.60849 5.69647 7.56239 5.8125 7.56239H13.5064L11.6278 5.68464C11.5456 5.60249 11.4994 5.49107 11.4994 5.37489C11.4994 5.25872 11.5456 5.14729 11.6278 5.06514C11.7099 4.98299 11.8213 4.93684 11.9375 4.93684C12.0537 4.93684 12.1651 4.98299 12.2472 5.06514L14.8722 7.69014C14.913 7.73078 14.9453 7.77906 14.9674 7.83221C14.9894 7.88537 15.0008 7.94235 15.0008 7.99989C15.0008 8.05744 14.9894 8.11442 14.9674 8.16757Z"
        fill="#272937"
      />
    </g>
    <defs>
      <clipPath id="clip0_921_37810">
        <rect width="14" height="14" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </svg>
);

/** Shared icon/avatar */
export const SharedWithMeSVG = (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_770_33828)">
      <path
        d="M4 9C4 7.67392 4.52678 6.40215 5.46447 5.46447C6.40215 4.52678 7.67392 4 9 4H39C40.3261 4 41.5979 4.52678 42.5355 5.46447C43.4732 6.40215 44 7.67392 44 9V39C44 40.3261 43.4732 41.5979 42.5355 42.5355C41.5979 43.4732 40.3261 44 39 44H9C7.67392 44 6.40215 43.4732 5.46447 42.5355C4.52678 41.5979 4 40.3261 4 39V9Z"
        fill="#F4F4F5"
      />
    </g>
    <g clipPath="url(#clip1_770_33828)">
      <path
        d="M13.9786 27.3352C15.0336 27.3352 16.0453 26.8995 16.7913 26.1242C17.5373 25.3488 17.9564 24.2971 17.9564 23.2005C17.9564 22.104 17.5373 21.0523 16.7913 20.2769C16.0453 19.5015 15.0336 19.0659 13.9786 19.0659C12.9234 19.0659 11.9114 19.5016 11.1653 20.2772C10.4192 21.0528 9.99998 22.1046 9.99998 23.2015C9.99998 24.2983 10.4192 25.3501 11.1653 26.1257C11.9114 26.9013 12.9234 27.337 13.9786 27.337V27.3352ZM30.5459 18.2692C31.6008 18.2692 32.6126 17.8336 33.3585 17.0582C34.1045 16.2828 34.5236 15.2312 34.5236 14.1346C34.5236 13.038 34.1045 11.9864 33.3585 11.211C32.6126 10.4356 31.6008 10 30.5459 10C29.4909 10 28.4791 10.4356 27.7332 11.211C26.9872 11.9864 26.5681 13.038 26.5681 14.1346C26.5681 15.2312 26.9872 16.2828 27.7332 17.0582C28.4791 17.8336 29.4909 18.2692 30.5459 18.2692ZM22.9509 33.8436C21.5448 33.5345 20.2225 32.904 19.0798 31.9979C17.9372 31.0918 17.0029 29.9328 16.3446 28.6048C15.2801 29.1079 14.0929 29.2603 12.9426 29.0414C13.738 31.0854 15.0042 32.895 16.63 34.3112C18.2558 35.7274 20.1914 36.7068 22.2666 37.1633C23.1941 37.3688 24.1426 37.4707 25.0911 37.4652C24.3608 36.4703 23.9527 35.2603 23.9256 34.0091C23.5982 33.9709 23.2729 33.9156 22.9509 33.8436ZM29.6499 38C30.1722 38 30.6895 37.8931 31.1721 37.6853C31.6547 37.4775 32.0932 37.1729 32.4625 36.789C32.8319 36.4051 33.1249 35.9493 33.3248 35.4476C33.5247 34.946 33.6276 34.4084 33.6276 33.8654C33.6276 33.3224 33.5247 32.7848 33.3248 32.2831C33.1249 31.7815 32.8319 31.3257 32.4625 30.9418C32.0932 30.5579 31.6547 30.2533 31.1721 30.0455C30.6895 29.8377 30.1722 29.7308 29.6499 29.7308C28.5949 29.7308 27.5831 30.1664 26.8372 30.9418C26.0912 31.7172 25.6721 32.7688 25.6721 33.8654C25.6721 34.962 26.0912 36.0136 26.8372 36.789C27.5831 37.5644 28.5949 38 29.6499 38ZM35.1851 32.3465C36.8908 30.1106 37.8724 27.3712 37.9897 24.5203C38.1069 21.6694 37.3537 18.8529 35.8379 16.4739C35.3788 17.599 34.598 18.5503 33.6014 19.1987C34.3968 20.7604 34.7857 22.511 34.7296 24.2771C34.6734 26.0432 34.1741 27.7633 33.2811 29.2669C34.2123 30.0591 34.8788 31.137 35.1851 32.3465ZM13.6724 17.2724C14.8397 17.2088 15.9979 17.5173 16.9921 18.1564C17.8689 16.8397 19.0348 15.7589 20.3932 15.0036C21.7517 14.2482 23.2637 13.84 24.8041 13.8126C24.8689 12.5939 25.2889 11.4243 26.0116 10.4602C23.5456 10.2666 21.0773 10.8039 18.8933 12.0097C16.7092 13.2154 14.8989 15.0403 13.6724 17.2724Z"
        fill="#B3B4B9"
      />
    </g>
    <defs>
      <clipPath id="clip0_770_33828">
        <rect width="40" height="40" fill="white" transform="translate(4 4)" />
      </clipPath>
      <clipPath id="clip1_770_33828">
        <rect
          width="28"
          height="28"
          fill="white"
          transform="translate(10 10)"
        />
      </clipPath>
    </defs>
  </svg>
);

/** Empty Organisation state graphic */
export const EmptyStateOrganisationSVG = (
  <svg
    width="376"
    height="368"
    viewBox="0 0 376 368"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="4" width="368" height="368" rx="184" fill="#F2F7FF" />
    <g filter="url(#filter0_d_553_38141)">
      <rect x="24" y="60" width="328" height="64" rx="16" fill="white" />
      <rect x="40" y="76" width="32" height="32" rx="8" fill="#E5E5E7" />
      <rect x="88" y="84" width="136" height="16" rx="8" fill="#E5E5E7" />
      <circle cx="260" cy="92" r="11.5" fill="#E5E5E7" stroke="white" />
      <circle cx="276" cy="92" r="11.5" fill="#E5E5E7" stroke="white" />
      <circle cx="292" cy="92" r="11.5" fill="#E5E5E7" stroke="white" />
      <circle cx="308" cy="92" r="11.5" fill="#E5E5E7" stroke="white" />
      <circle cx="324" cy="92" r="11.5" fill="#E5E5E7" stroke="white" />
    </g>
    <g filter="url(#filter1_d_553_38141)">
      <rect x="24" y="156" width="328" height="64" rx="16" fill="white" />
      <rect x="40" y="172" width="32" height="32" rx="8" fill="#E5E5E7" />
      <rect x="88" y="180" width="136" height="16" rx="8" fill="#E5E5E7" />
      <circle cx="260" cy="188" r="11.5" fill="#E5E5E7" stroke="white" />
      <circle cx="276" cy="188" r="11.5" fill="#E5E5E7" stroke="white" />
      <circle cx="292" cy="188" r="11.5" fill="#E5E5E7" stroke="white" />
      <circle cx="308" cy="188" r="11.5" fill="#E5E5E7" stroke="white" />
      <circle cx="324" cy="188" r="11.5" fill="#E5E5E7" stroke="white" />
    </g>
    <g filter="url(#filter2_d_553_38141)">
      <rect x="24" y="252" width="328" height="64" rx="16" fill="white" />
      <rect x="40" y="268" width="32" height="32" rx="8" fill="#E5E5E7" />
      <rect x="88" y="276" width="136" height="16" rx="8" fill="#E5E5E7" />
      <circle cx="260" cy="284" r="11.5" fill="#E5E5E7" stroke="white" />
      <circle cx="276" cy="284" r="11.5" fill="#E5E5E7" stroke="white" />
      <circle cx="292" cy="284" r="11.5" fill="#E5E5E7" stroke="white" />
      <circle cx="308" cy="284" r="11.5" fill="#E5E5E7" stroke="white" />
      <circle cx="324" cy="284" r="11.5" fill="#E5E5E7" stroke="white" />
    </g>
    <rect
      x="4"
      y="184"
      width="368"
      height="184"
      fill="url(#paint0_linear_553_38141)"
    />
    <defs>
      <filter
        id="filter0_d_553_38141"
        x="0"
        y="42"
        width="376"
        height="112"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="6" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_553_38141"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_553_38141"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_553_38141"
        x="0"
        y="138"
        width="376"
        height="112"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="6" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_553_38141"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_553_38141"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_553_38141"
        x="0"
        y="234"
        width="376"
        height="112"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="6" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_553_38141"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_553_38141"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_553_38141"
        x1="188"
        y1="184"
        x2="188"
        y2="368"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);

/** Empty Workspace state graphic */
export const EmptyStateWorkspaceSVG = (
  <svg
    width="376"
    height="368"
    viewBox="0 0 376 368"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="368" height="368" rx="184" fill="#F2F7FF" />
    <g filter="url(#filter0_d_553_38200)">
      <rect x="24" y="52" width="328" height="120" rx="16" fill="white" />
      <rect x="40" y="68" width="32" height="32" rx="8" fill="#E5E5E7" />
      <rect x="88" y="68" width="168" height="16" rx="8" fill="#E5E5E7" />
      <rect x="88" y="92" width="208" height="8" rx="4" fill="#F4F4F5" />
      <circle cx="260" cy="144" r="11.5" fill="#E5E5E7" stroke="white" />
      <circle cx="276" cy="144" r="11.5" fill="#E5E5E7" stroke="white" />
      <circle cx="292" cy="144" r="11.5" fill="#E5E5E7" stroke="white" />
      <circle cx="308" cy="144" r="11.5" fill="#E5E5E7" stroke="white" />
      <circle cx="324" cy="144" r="11.5" fill="#E5E5E7" stroke="white" />
      <path
        d="M44.625 75.0625C44.625 74.416 44.8818 73.796 45.3389 73.3389C45.796 72.8818 46.416 72.625 47.0625 72.625H51.9375C52.584 72.625 53.204 72.8818 53.6611 73.3389C54.1182 73.796 54.375 74.416 54.375 75.0625V79.9375C54.375 80.584 54.1182 81.204 53.6611 81.6611C53.204 82.1182 52.584 82.375 51.9375 82.375H47.0625C46.416 82.375 45.796 82.1182 45.3389 81.6611C44.8818 81.204 44.625 80.584 44.625 79.9375V75.0625ZM57.625 75.0625C57.625 74.416 57.8818 73.796 58.3389 73.3389C58.796 72.8818 59.416 72.625 60.0625 72.625H64.9375C65.584 72.625 66.204 72.8818 66.6611 73.3389C67.1182 73.796 67.375 74.416 67.375 75.0625V79.9375C67.375 80.584 67.1182 81.204 66.6611 81.6611C66.204 82.1182 65.584 82.375 64.9375 82.375H60.0625C59.416 82.375 58.796 82.1182 58.3389 81.6611C57.8818 81.204 57.625 80.584 57.625 79.9375V75.0625ZM44.625 88.0625C44.625 87.416 44.8818 86.796 45.3389 86.3389C45.796 85.8818 46.416 85.625 47.0625 85.625H51.9375C52.584 85.625 53.204 85.8818 53.6611 86.3389C54.1182 86.796 54.375 87.416 54.375 88.0625V92.9375C54.375 93.584 54.1182 94.204 53.6611 94.6611C53.204 95.1182 52.584 95.375 51.9375 95.375H47.0625C46.416 95.375 45.796 95.1182 45.3389 94.6611C44.8818 94.204 44.625 93.584 44.625 92.9375V88.0625ZM57.625 88.0625C57.625 87.416 57.8818 86.796 58.3389 86.3389C58.796 85.8818 59.416 85.625 60.0625 85.625H64.9375C65.584 85.625 66.204 85.8818 66.6611 86.3389C67.1182 86.796 67.375 87.416 67.375 88.0625V92.9375C67.375 93.584 67.1182 94.204 66.6611 94.6611C66.204 95.1182 65.584 95.375 64.9375 95.375H60.0625C59.416 95.375 58.796 95.1182 58.3389 94.6611C57.8818 94.204 57.625 93.584 57.625 92.9375V88.0625Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter1_d_553_38200)">
      <rect x="24" y="204" width="328" height="120" rx="16" fill="white" />
      <rect x="40" y="220" width="32" height="32" rx="8" fill="#E5E5E7" />
      <rect x="88" y="220" width="168" height="16" rx="8" fill="#E5E5E7" />
      <rect x="88" y="244" width="208" height="8" rx="4" fill="#F4F4F5" />
      <circle cx="260" cy="296" r="11.5" fill="#E5E5E7" stroke="white" />
      <circle cx="276" cy="296" r="11.5" fill="#E5E5E7" stroke="white" />
      <circle cx="292" cy="296" r="11.5" fill="#E5E5E7" stroke="white" />
      <circle cx="308" cy="296" r="11.5" fill="#E5E5E7" stroke="white" />
      <circle cx="324" cy="296" r="11.5" fill="#E5E5E7" stroke="white" />
      <path
        d="M44.625 227.062C44.625 226.416 44.8818 225.796 45.3389 225.339C45.796 224.882 46.416 224.625 47.0625 224.625H51.9375C52.584 224.625 53.204 224.882 53.6611 225.339C54.1182 225.796 54.375 226.416 54.375 227.062V231.938C54.375 232.584 54.1182 233.204 53.6611 233.661C53.204 234.118 52.584 234.375 51.9375 234.375H47.0625C46.416 234.375 45.796 234.118 45.3389 233.661C44.8818 233.204 44.625 232.584 44.625 231.938V227.062ZM57.625 227.062C57.625 226.416 57.8818 225.796 58.3389 225.339C58.796 224.882 59.416 224.625 60.0625 224.625H64.9375C65.584 224.625 66.204 224.882 66.6611 225.339C67.1182 225.796 67.375 226.416 67.375 227.062V231.938C67.375 232.584 67.1182 233.204 66.6611 233.661C66.204 234.118 65.584 234.375 64.9375 234.375H60.0625C59.416 234.375 58.796 234.118 58.3389 233.661C57.8818 233.204 57.625 232.584 57.625 231.938V227.062ZM44.625 240.062C44.625 239.416 44.8818 238.796 45.3389 238.339C45.796 237.882 46.416 237.625 47.0625 237.625H51.9375C52.584 237.625 53.204 237.882 53.6611 238.339C54.1182 238.796 54.375 239.416 54.375 240.062V244.938C54.375 245.584 54.1182 246.204 53.6611 246.661C53.204 247.118 52.584 247.375 51.9375 247.375H47.0625C46.416 247.375 45.796 247.118 45.3389 246.661C44.8818 246.204 44.625 245.584 44.625 244.938V240.062ZM57.625 240.062C57.625 239.416 57.8818 238.796 58.3389 238.339C58.796 237.882 59.416 237.625 60.0625 237.625H64.9375C65.584 237.625 66.204 237.882 66.6611 238.339C67.1182 238.796 67.375 239.416 67.375 240.062V244.938C67.375 245.584 67.1182 246.204 66.6611 246.661C66.204 247.118 65.584 247.375 64.9375 247.375H60.0625C59.416 247.375 58.796 247.118 58.3389 246.661C57.8818 246.204 57.625 245.584 57.625 244.938V240.062Z"
        fill="white"
      />
    </g>
    <rect
      y="184"
      width="368"
      height="184"
      fill="url(#paint0_linear_553_38200)"
    />
    <defs>
      <filter
        id="filter0_d_553_38200"
        x="0"
        y="34"
        width="376"
        height="168"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="6" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_553_38200"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_553_38200"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_553_38200"
        x="0"
        y="186"
        width="376"
        height="168"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="6" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_553_38200"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_553_38200"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_553_38200"
        x1="184"
        y1="184"
        x2="184"
        y2="368"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);

/** Empty Campaign state graphic */
export const EmptyStateCampaignSVG = (
  <svg
    width="376"
    height="368"
    viewBox="0 0 376 368"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="368" height="368" rx="184" fill="#F2F7FF" />
    <g filter="url(#filter0_d_553_38261)">
      <rect x="24" y="52" width="328" height="272" rx="16" fill="white" />
      <rect x="40" y="68" width="168" height="16" rx="8" fill="#E5E5E7" />
      <rect x="40" y="92" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="108" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="124" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="140" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="156" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="172" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="188" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="204" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="220" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="236" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="252" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="268" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="284" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="300" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="92" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="108" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="124" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="140" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="156" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="172" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="188" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="204" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="220" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="236" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="252" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="268" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="284" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="300" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="92" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="108" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="124" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="140" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="156" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="172" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="188" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="204" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="220" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="236" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="252" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="268" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="284" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="300" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="92" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="108" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="124" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="140" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="156" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="172" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="188" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="204" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="220" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="236" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="252" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="268" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="284" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="300" width="68" height="8" rx="4" fill="#E5E5E7" />
    </g>
    <rect
      y="184"
      width="368"
      height="184"
      fill="url(#paint0_linear_553_38261)"
    />
    <defs>
      <filter
        id="filter0_d_553_38261"
        x="0"
        y="34"
        width="376"
        height="320"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="6" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_553_38261"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_553_38261"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_553_38261"
        x1="184"
        y1="184"
        x2="184"
        y2="368"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);

/** Empty Shared-With-Me state graphic */
export const EmptyStateSharedSVG = (
  <svg
    width="376"
    height="368"
    viewBox="0 0 376 368"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="368" height="368" rx="184" fill="#F2F7FF" />
    <g filter="url(#filter0_d_553_38199)">
      <rect x="24" y="52" width="328" height="272" rx="16" fill="white" />
      <rect x="40" y="68" width="168" height="16" rx="8" fill="#E5E5E7" />
      <rect x="40" y="92" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="108" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="124" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="140" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="156" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="172" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="188" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="204" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="220" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="236" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="252" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="268" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="284" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="40" y="300" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="92" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="108" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="124" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="140" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="156" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="172" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="188" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="204" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="220" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="236" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="252" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="268" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="284" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="116" y="300" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="92" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="108" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="124" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="140" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="156" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="172" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="188" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="204" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="220" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="236" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="252" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="268" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="284" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="192" y="300" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="92" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="108" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="124" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="140" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="156" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="172" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="188" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="204" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="220" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="236" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="252" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="268" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="284" width="68" height="8" rx="4" fill="#E5E5E7" />
      <rect x="268" y="300" width="68" height="8" rx="4" fill="#E5E5E7" />
      <circle cx="184" cy="188" r="44" fill="white" />
      <g clipPath="url(#clip0_553_38199)">
        <path
          d="M169.684 192.765C171.191 192.765 172.636 192.142 173.702 191.035C174.768 189.927 175.366 188.424 175.366 186.858C175.366 185.291 174.768 183.789 173.702 182.681C172.636 181.574 171.191 180.951 169.684 180.951C168.176 180.951 166.731 181.574 165.665 182.682C164.599 183.79 164 185.292 164 186.859C164 188.426 164.599 189.929 165.665 191.037C166.731 192.145 168.176 192.767 169.684 192.767V192.765ZM193.351 179.813C194.858 179.813 196.304 179.191 197.369 178.083C198.435 176.975 199.034 175.473 199.034 173.907C199.034 172.34 198.435 170.838 197.369 169.73C196.304 168.622 194.858 168 193.351 168C191.844 168 190.399 168.622 189.333 169.73C188.267 170.838 187.669 172.34 187.669 173.907C187.669 175.473 188.267 176.975 189.333 178.083C190.399 179.191 191.844 179.813 193.351 179.813ZM182.501 202.062C180.493 201.621 178.604 200.72 176.971 199.426C175.339 198.131 174.004 196.475 173.064 194.578C171.543 195.297 169.847 195.515 168.204 195.202C169.34 198.122 171.149 200.707 173.471 202.73C175.794 204.753 178.559 206.153 181.524 206.805C182.849 207.098 184.204 207.244 185.559 207.236C184.515 205.815 183.932 204.086 183.894 202.299C183.426 202.244 182.961 202.165 182.501 202.062ZM192.071 208C192.817 208 193.556 207.847 194.246 207.55C194.935 207.254 195.562 206.818 196.089 206.27C196.617 205.722 197.036 205.07 197.321 204.354C197.607 203.637 197.754 202.869 197.754 202.093C197.754 201.318 197.607 200.55 197.321 199.833C197.036 199.116 196.617 198.465 196.089 197.917C195.562 197.368 194.935 196.933 194.246 196.636C193.556 196.34 192.817 196.187 192.071 196.187C190.564 196.187 189.119 196.809 188.053 197.917C186.987 199.025 186.389 200.527 186.389 202.093C186.389 203.66 186.987 205.162 188.053 206.27C189.119 207.378 190.564 208 192.071 208ZM199.979 199.924C202.415 196.729 203.818 192.816 203.985 188.743C204.153 184.671 203.077 180.647 200.911 177.248C200.255 178.856 199.14 180.215 197.716 181.141C198.853 183.372 199.408 185.873 199.328 188.396C199.248 190.919 198.534 193.376 197.259 195.524C198.589 196.656 199.541 198.196 199.979 199.924ZM169.246 178.389C170.914 178.298 172.569 178.739 173.989 179.652C175.241 177.771 176.907 176.227 178.848 175.148C180.788 174.069 182.948 173.486 185.149 173.447C185.241 171.706 185.841 170.035 186.874 168.657C183.351 168.381 179.825 169.148 176.705 170.871C173.585 172.593 170.998 175.2 169.246 178.389Z"
          fill="#B3B4B9"
        />
      </g>
    </g>
    <rect
      y="184"
      width="368"
      height="184"
      fill="url(#paint0_linear_553_38199)"
    />
    <defs>
      <filter
        id="filter0_d_553_38199"
        x="0"
        y="34"
        width="376"
        height="320"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="6" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_553_38199"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_553_38199"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_553_38199"
        x1="184"
        y1="184"
        x2="184"
        y2="368"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_553_38199">
        <rect
          width="40"
          height="40"
          fill="white"
          transform="translate(164 168)"
        />
      </clipPath>
    </defs>
  </svg>
);

/* No access (unauthorised) campaign state **/
export const NoAccessEmptyStateSVG = (
  <svg
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="96" height="96" rx="48" fill="#F2F7FF" />
    <path
      d="M0 48H96C96 74.5097 74.5097 96 48 96C21.4903 96 0 74.5097 0 48Z"
      fill="url(#paint0_linear_2444_167931)"
    />
    <g filter="url(#filter0_d_2444_167931)">
      <rect x="8" y="12" width="80" height="72" rx="4.17391" fill="white" />
      <rect x="12" y="16" width="44" height="4" rx="2" fill="#E5E5E7" />
      <rect x="12" y="24" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="28" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="32" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="36" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="40" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="44" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="48" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="52" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="56" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="60" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="64" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="68" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="72" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="76" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6001" y="24" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6001" y="28" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6001" y="32" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6001" y="36" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6001" y="40" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6001" y="44" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6001" y="48" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6001" y="52" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6001" y="56" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6001" y="60" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6001" y="64" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6001" y="68" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6001" y="72" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6001" y="76" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="24" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="28" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="32" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="36" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="40" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="44" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="48" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="52" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="56" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="60" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="64" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="68" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="72" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="76" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="24" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="28" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="32" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="36" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="40" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="44" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="48" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="52" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="56" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="60" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="64" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="68" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="72" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="76" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <g filter="url(#filter1_d_2444_167931)">
        <circle cx="48" cy="52" r="16" fill="white" />
      </g>
      <path
        d="M48 45.875C48.4641 45.875 48.9092 46.0594 49.2374 46.3876C49.5656 46.7158 49.75 47.1609 49.75 47.625V51.125H46.25V47.625C46.25 47.1609 46.4344 46.7158 46.7626 46.3876C47.0908 46.0594 47.5359 45.875 48 45.875ZM50.625 51.125V47.625C50.625 46.9288 50.3484 46.2611 49.8562 45.7688C49.3639 45.2766 48.6962 45 48 45C47.3038 45 46.6361 45.2766 46.1438 45.7688C45.6516 46.2611 45.375 46.9288 45.375 47.625V51.125C44.9109 51.125 44.4658 51.3094 44.1376 51.6376C43.8094 51.9658 43.625 52.4109 43.625 52.875V57.25C43.625 57.7141 43.8094 58.1592 44.1376 58.4874C44.4658 58.8156 44.9109 59 45.375 59H50.625C51.0891 59 51.5342 58.8156 51.8624 58.4874C52.1906 58.1592 52.375 57.7141 52.375 57.25V52.875C52.375 52.4109 52.1906 51.9658 51.8624 51.6376C51.5342 51.3094 51.0891 51.125 50.625 51.125Z"
        fill="#5D5F69"
      />
      <path
        d="M8 48H88V80C88 82.2091 86.2091 84 84 84H12C9.79086 84 8 82.2091 8 80V48Z"
        fill="url(#paint1_linear_2444_167931)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_2444_167931"
        x="1.73913"
        y="7.30435"
        width="92.5217"
        height="84.5217"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.56522" />
        <feGaussianBlur stdDeviation="3.13043" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2444_167931"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2444_167931"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_2444_167931"
        x="24"
        y="30"
        width="48"
        height="48"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2444_167931"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2444_167931"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2444_167931"
        x1="48"
        y1="48"
        x2="48"
        y2="96"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2444_167931"
        x1="48"
        y1="48"
        x2="48"
        y2="84"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);

export const CampaignLinksEmptyStateSVG = (
  <svg
    width="312"
    height="312"
    viewBox="0 0 312 312"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="60" y="36" width="192" height="192" rx="96" fill="#F2F7FF" />
    <g filter="url(#filter0_d_490_119382)">
      <rect x="76" y="56" width="160" height="40" rx="8" fill="white" />
      <rect x="84" y="64" width="32" height="24" rx="8" fill="#E5E5E7" />
      <rect x="124" y="68" width="104" height="16" rx="8" fill="#E5E5E7" />
    </g>
    <g filter="url(#filter1_d_490_119382)">
      <rect x="76" y="112" width="160" height="40" rx="8" fill="white" />
      <rect x="84" y="120" width="32" height="24" rx="8" fill="#E5E5E7" />
      <rect x="124" y="124" width="104" height="16" rx="8" fill="#E5E5E7" />
    </g>
    <g filter="url(#filter2_d_490_119382)">
      <rect x="76" y="168" width="160" height="40" rx="8" fill="white" />
      <rect x="84" y="176" width="32" height="24" rx="8" fill="#E5E5E7" />
      <rect x="124" y="180" width="104" height="16" rx="8" fill="#E5E5E7" />
    </g>
    <rect
      x="60"
      y="132"
      width="192"
      height="96"
      fill="url(#paint0_linear_490_119382)"
    />
    <g filter="url(#filter3_d_490_119382)">
      <circle cx="156" cy="132" r="28" fill="white" />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M152.504 128.562C152.74 127.818 153.151 127.143 153.702 126.591L156.673 123.621C157.587 122.707 158.827 122.193 160.12 122.193C161.413 122.193 162.653 122.707 163.568 123.621C164.482 124.535 164.996 125.775 164.996 127.068C164.996 128.361 164.482 129.601 163.568 130.516L161.338 132.745C161.382 132.043 161.312 131.336 161.13 130.654L162.419 129.367C163.029 128.757 163.371 127.93 163.371 127.067C163.371 126.205 163.029 125.378 162.419 124.768C161.809 124.158 160.982 123.816 160.119 123.816C159.257 123.816 158.43 124.158 157.82 124.768L154.851 127.739C154.448 128.142 154.158 128.644 154.01 129.195C153.862 129.746 153.862 130.326 154.01 130.877C154.157 131.429 154.447 131.931 154.85 132.334C155.254 132.738 155.756 133.028 156.307 133.176L155.048 134.437C154.344 134.101 153.731 133.601 153.261 132.979C152.791 132.357 152.477 131.631 152.345 130.862C152.213 130.094 152.267 129.305 152.504 128.562ZM150.662 129.631L150.662 129.631V129.629C150.662 129.63 150.662 129.63 150.662 129.631ZM150.662 129.631L148.432 131.86C147.518 132.775 147.004 134.015 147.004 135.308C147.004 136.601 147.518 137.841 148.432 138.755C149.347 139.669 150.587 140.183 151.88 140.183C153.173 140.183 154.413 139.669 155.327 138.755L158.298 135.783C158.849 135.232 159.26 134.556 159.496 133.813C159.733 133.07 159.787 132.281 159.655 131.512C159.523 130.744 159.209 130.018 158.739 129.396C158.269 128.774 157.656 128.274 156.952 127.938L156 128.89C155.903 128.987 155.819 129.095 155.75 129.213C156.293 129.369 156.787 129.665 157.181 130.07C157.576 130.476 157.857 130.977 157.999 131.525C158.14 132.072 158.136 132.647 157.987 133.193C157.838 133.739 157.549 134.236 157.149 134.636L154.18 137.606C153.57 138.216 152.743 138.559 151.881 138.559C151.018 138.559 150.191 138.216 149.581 137.606C148.971 136.996 148.629 136.169 148.629 135.307C148.629 134.444 148.971 133.617 149.581 133.007L150.87 131.72C150.688 131.04 150.618 130.334 150.662 129.631Z"
      fill="#B3B4B9"
    />
    <defs>
      <filter
        id="filter0_d_490_119382"
        x="52"
        y="38"
        width="208"
        height="88"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="6" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_490_119382"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_490_119382"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_490_119382"
        x="52"
        y="94"
        width="208"
        height="88"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="6" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_490_119382"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_490_119382"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_490_119382"
        x="52"
        y="150"
        width="208"
        height="88"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="6" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_490_119382"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_490_119382"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_490_119382"
        x="0"
        y="0"
        width="312"
        height="312"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="24" />
        <feGaussianBlur stdDeviation="64" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_490_119382"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_490_119382"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_490_119382"
        x1="156"
        y1="132"
        x2="156"
        y2="228"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);

/* No access (archived) campaign state **/
export const NoAccessArchivedEmptyStateSVG = (
  <svg
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="96" height="96" rx="48" fill="#F2F7FF" />
    <path
      d="M0 48H96C96 74.5097 74.5097 96 48 96C21.4903 96 0 74.5097 0 48Z"
      fill="url(#paint0_linear_2828_5476)"
    />
    <g filter="url(#filter0_d_2828_5476)">
      <rect x="8" y="12" width="80" height="72" rx="4.17391" fill="white" />
      <rect x="12" y="16" width="44" height="4" rx="2" fill="#E5E5E7" />
      <rect x="12" y="24" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="28" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="32" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="36" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="40" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="44" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="48" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="52" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="56" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="60" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="64" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="68" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="72" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="12" y="76" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6" y="24" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6" y="28" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6" y="32" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6" y="36" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6" y="40" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6" y="44" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6" y="48" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6" y="52" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6" y="56" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6" y="60" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6" y="64" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6" y="68" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6" y="72" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="30.6" y="76" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="24" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="28" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="32" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="36" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="40" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="44" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="48" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="52" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="56" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="60" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="64" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="68" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="72" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="49.2" y="76" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="24" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="28" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="32" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="36" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="40" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="44" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="48" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="52" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="56" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="60" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="64" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="68" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="72" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <rect x="67.8" y="76" width="16.6" height="2" rx="1" fill="#E5E5E7" />
      <g filter="url(#filter1_d_2828_5476)">
        <circle cx="48" cy="52" r="16" fill="white" />
      </g>
      <g clip-path="url(#clip0_2828_5476)">
        <path
          d="M48.8592 46.3704C48.7726 46.2195 48.6477 46.0942 48.4972 46.007C48.3466 45.9198 48.1757 45.8739 48.0017 45.8739C47.8278 45.8739 47.6569 45.9198 47.5063 46.007C47.3557 46.0942 47.2308 46.2195 47.1442 46.3704L41.1444 56.579C40.7445 57.2598 41.224 58.1251 42.0019 58.1251H54.0007C54.7786 58.1251 55.259 57.2589 54.8582 56.579L48.8592 46.3704ZM48 49.3751C48.4681 49.3751 48.8347 49.7794 48.7875 50.2458L48.4812 53.3144C48.4709 53.4349 48.4158 53.5472 48.3267 53.6291C48.2376 53.7109 48.121 53.7563 48 53.7563C47.879 53.7563 47.7624 53.7109 47.6733 53.6291C47.5842 53.5472 47.529 53.4349 47.5187 53.3144L47.2125 50.2458C47.2015 50.1357 47.2137 50.0246 47.2482 49.9195C47.2828 49.8145 47.339 49.7178 47.4132 49.6358C47.4873 49.5538 47.5779 49.4882 47.679 49.4433C47.78 49.3984 47.8894 49.3752 48 49.3751ZM48.0017 54.6251C48.2338 54.6251 48.4564 54.7173 48.6205 54.8814C48.7845 55.0455 48.8767 55.2681 48.8767 55.5001C48.8767 55.7322 48.7845 55.9548 48.6205 56.1189C48.4564 56.283 48.2338 56.3751 48.0017 56.3751C47.7697 56.3751 47.5471 56.283 47.383 56.1189C47.2189 55.9548 47.1267 55.7322 47.1267 55.5001C47.1267 55.2681 47.2189 55.0455 47.383 54.8814C47.5471 54.7173 47.7697 54.6251 48.0017 54.6251Z"
          fill="#FFB649"
        />
      </g>
      <path
        d="M8 48H88V80C88 82.2091 86.2091 84 84 84H12C9.79086 84 8 82.2091 8 80V48Z"
        fill="url(#paint1_linear_2828_5476)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_2828_5476"
        x="1.73913"
        y="7.30435"
        width="92.5217"
        height="84.5217"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.56522" />
        <feGaussianBlur stdDeviation="3.13043" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2828_5476"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2828_5476"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_2828_5476"
        x="24"
        y="30"
        width="48"
        height="48"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2828_5476"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2828_5476"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2828_5476"
        x1="48"
        y1="48"
        x2="48"
        y2="96"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2828_5476"
        x1="48"
        y1="48"
        x2="48"
        y2="84"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_2828_5476">
        <rect
          width="14"
          height="14"
          fill="white"
          transform="translate(41 45)"
        />
      </clipPath>
    </defs>
  </svg>
);
